import { Components, Theme } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

export const MuiPickersOutlinedInput: Components<Theme>['MuiPickersOutlinedInput'] =
  {
    defaultProps: {
      notched: false,
    },
    styleOverrides: {
      root: {
        backgroundColor: scssVariables.ColorBlack00,
        legend: {
          /*
           * somehow the notch is still there when the pickers are focused,
           * so we hide by setting width to 0 so that the vertical space is still used correctly by the element
           */
          width: '0px',
        },
      },
    },
  };
